<template>
  <div class="rounded bg-light-gray mt-3 pb-3" v-if="empty">
    <div class="row d-flex flex-row-reverse pt-3 px-3">
      <action-button
        v-if="!show"
        :class="isMobile ? 'w-100 mx-3' : 'mx-3 float-right '"
        id="modal-btn-anadir"
        variant="outline-success"
        type="button"
        i="fa-solid fa-file"
        @click="generatePreviewReport"
      >
        Previsualizar el informe
      </action-button>
      <action-button
        v-else
        :class="isMobile ? 'd-sm-none' : 'mx-3 float-right'"
        id="modal-btn-anadir"
        variant="outline-danger"
        type="button"
        i="fa-solid fa-circle-xmark"
        @click="closeModal"
      >
        Cerrar
      </action-button>
    </div>
    <div
      v-if="show"
      class="row bg-white rounded-lg d-flex border-color--gray-2 mt-3 mx-3"
    >
      <div class="col-12 mt-3">
        <p class="font-weight-normal">
          Esta es una vista preliminar de las columnas seleccionadas y los datos
          asociados a cada una.
        </p>
        <div class="table-responsive">
          <custom-result-not-found v-if="tableHeaders.length == 0" />
          <table v-else class="table bordered table-bordered mb-2">
            <thead>
              <tr>
                <th
                  class="text-center"
                  v-for="head in tableHeaders"
                  :key="head"
                >
                  {{ head }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  class="text-center"
                  v-for="head in tableHeaders"
                  :key="head"
                >
                  {{ validateValue(report[head]) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-12 py-2">
        <action-button
          id="modal-btn-anadir"
          variant="outline-danger"
          type="button"
          i="fa-solid fa-circle-xmark"
          @click="closeModal"
          :class="isMobile ? 'w-100' : 'd-lg-none'"
        >
          Cerrar
        </action-button>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton'
import CustomResultNotFound from 'custom-result-not-found'
import SpecialService from '@/services/api/special.api'
import { date } from '@/utils/filters'
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'PreviewReport',
  components: {
    ActionButton,
    CustomResultNotFound,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    copyMode: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    show: false,
    report: {},
  }),
  computed: {
    isMobile() {
      return this.$store.getters['$_app/getIsMobileDensity']
    },
    tableHeaders() {
      return Object.keys(this.report)
    },
    validateValue() {
      return (value) => {
        if (typeof value === 'object') {
          return _.isEmpty(value) ? '-' : value
        }
        if (moment(value.split(' ')[0], 'MM/DD/YYYY', true).isValid()) {
          return date(value.split(' ')[0])
        }
        return value
      }
    },
    empty() {
      return this.value.columns && this.value.columns.length > 0
    },
  },
  methods: {
    async generatePreviewReport() {
      this.show = true
      const subTopics = this.value.columns.map((i) => i.subTopicId)

      const uniqueSubTopics = [...new Set(subTopics)]

      const { data } = await SpecialService.getPreview({
        topicId:
          this.editMode || this.copyMode
            ? this.value.topic.id
            : parseInt(this.value.topic),
        columns: this.value.columns
          .filter((e) => !e['auto-check'])
          .map((x, idx) => ({
            id: x.id,
            subTopicId: x.subTopicId,
            tableId: x.tableId,
            order: idx,
          })),
        SelectedFilterByLocation: this.value.locationFilters,
        SubTopics: uniqueSubTopics,
      })
      this.report = { ...data?.data }
      this.$emit('preview', true)
    },
    closeModal() {
      this.show = false
      this.report = {}
      this.$emit('preview', false)
    },
  },
}
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 0.5rem;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 1px white;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #e2e2e2;
  border-radius: 10px;
}

table {
  border-collapse: separate !important;
  border-spacing: 0;
  width: 100%;
}

td {
  padding: 1em;
  border: 1px, 1px, 1px, 0px solid #e2e2e2 !important;
  min-width: 200px !important;
}

.bordered {
  -moz-border-radius: 6px;
  -webkit-border-radius: 6px;
  border-radius: 6px;
}

.bordered th {
  padding: 10px;
  text-align: left;
}

.bordered th {
  background-color: #b5c3bc;
}

.bordered td:first-child,
.bordered th:first-child {
  border-left: none;
}

.bordered th:first-child {
  -moz-border-radius: 6px 0 0 0;
  -webkit-border-radius: 6px 0 0 0;
  border-radius: 6px 0 0 0;
}

.bordered th:last-child {
  -moz-border-radius: 0 6px 0 0;
  -webkit-border-radius: 0 6px 0 0;
  border-radius: 0 6px 0 0;
}

.bordered th:only-child {
  -moz-border-radius: 6px 6px 0 0;
  -webkit-border-radius: 6px 6px 0 0;
  border-radius: 6px 6px 0 0;
}

.bordered tr:last-child td:first-child {
  -moz-border-radius: 0 0 0 6px;
  -webkit-border-radius: 0 0 0 6px;
  border-radius: 0 0 0 6px;
}

.bordered tr:last-child td:last-child {
  -moz-border-radius: 0 0 6px 0;
  -webkit-border-radius: 0 0 6px 0;
  border-radius: 0 0 6px 0;
}
</style>
